/*
 * FileName : index.tsx
 * ProjectName : admin
 * Author : terrorblade
 * Created Date: 2021-10-28 15:49:54
 * Description :
 * -----
 * Last Modified:
 * Modified By :
 * -----
 * Copyright (c) 2021 Magina Corporation. All rights reserved.
 */

import { DeviceRow } from 'src/api/common/type';
import { get, post } from 'src/api/http';
import { ImportProgressData, ReturnPageData, TaskListMess } from 'src/api/types.d';
import * as types from './type';

class DeviceMonitor {
    getDcuOnlineStatus (data: types.DcuOnlineStatusParams): Promise<ReturnPageData<types.DcuOnlineStatusData>> {
        return post('/amr/dcu-online-status/list', data);
    }
    getMeterOnlineStatus (data: types.MeterOnlineStatusParams): Promise<ReturnPageData<types.MeterOnlineStatusData>> {
        return post('/amr/dcu-online-status/meter-online', data);
    }
    getDcuOnlineLog (data: types.DcuOnlineLogParams):Promise<ReturnPageData<types.DcuOnlineLogData>> {
        return post('/amr/dcu-online-status/log', data);
    }
    updateMeter (data: types.UpdateMeterParams):Promise<TaskListMess> {
        return post('/amr/dcu-online-status/update-meter', data);
    }
    updateDcu (data: types.UpdateDcuParams):Promise<TaskListMess> {
        return post('/amr/dcu-online-status/update-dcu', data);
    }
    getMeterOnlineRate (data: types.GetMeterOnlineRate): Promise<ReturnPageData<types.MeterOnlineRateRows>> {
        return post('/amr/dcu-online-status/meter-online-rate', data);
    }
    refreshMeterStatus (): Promise<any> {
        return post('/amr/dcu-online-status/refresh-meter-status');
    }
    scanDevice (data:types.ScanDeviceParams): Promise<DeviceRow[]> {
        return get('/amr/dcu-online-status/scan-device', data);
    }
    createReadMeterTask (cstIdList: string[]): Promise<string> {
        return post('/amr/dcu-online-status/create-read-meter-task', cstIdList);
    }
    getDeviceStatusById (ids: types.RefreshDeviceParams[]): Promise<types.RefreshDeviceRows[]> {
        return post('/amr/dcu-online-status/get-device-status-by-id', ids);
    }
    getTopTenDcuDownLine (statisticalDimension: '0' | '1' | '2'): Promise<types.OffLineDeviceListRow[]> {
        return get('/amr/dcu-online-status/off-line-top-ten', {statisticalDimension});
    }
    getOffLineAll (data:types.QueryAllDeviceOfflineParam): Promise<ReturnPageData<types.QueryAllDeviceOfflineRow>> {
        return get('/amr/dcu-online-status/dcu-off-line-statistic', data);
    }
    getDcuOnlineMeter (dcuNo: string): Promise<types.QueryDCUOnlineMeters> {
        return get('/amr/dcu-online-status/dcu-online-meter-statistical', {dcuNo});
    }
    getDcuOverviewData (data: types.QueryDeviceOverviewParams): Promise<ReturnPageData<types.DeviceOverviewRows>> {
        return get('/amr/dcu-online-status/device-overview-list', data);
    }
    importDeviceInfo (fileId: string): Promise<string> {
        return get('/amr/dcu-online-status/import-adjust', {fileId});
    }
    importDeviceProgress (fileId: string): Promise<ImportProgressData> {
        return get('/amr/dcu-online-status/import-adjust-progress', {fileId});
    }
    importMaintance (fileId: string): Promise<string> {
        return get('/amr/dcu-online-status/import-Maintance', {fileId});
    }
    importMaintanceProgress (fileId: string): Promise<ImportProgressData> {
        return get('/amr/dcu-online-status/import-Maintance-progress', {fileId});
    }
    getMeterSnapshot (params: types.QueryMeterSnapshotParams): Promise<ReturnPageData<types.QueryMeterSnapshotRows>> {
        return post('/amr/dcu-online-status/meter-snapshot', params);
    }
}

export default new DeviceMonitor();
